import ETextAreaInput from '@/components/everridge/ETextAreaInput';
import ETextInput from '@/components/everridge/ETextInput';
import ECheckboxWithTextInput from '@/components/everridge/ECheckboxInput';
import { NotificationCreateFormData } from '@/features/notifications/validators/NotificationCreateValidator';
import { t } from 'i18next';
import { FC } from 'react';
import { Control } from 'react-hook-form';

type Props = {
	control: Control<NotificationCreateFormData>;
};

const NotificationCreateStep3: FC<Props> = ({ control }) => {
	return (
		<div className='flex flex-col gap-4'>
			<ETextInput
				control={control}
				fieldName={'title'}
				label={t('elements.form.title.label')}
				placeholder={t(
					'main.notifications.components.create.form.title.placeholder',
				)}
			/>
			<ETextAreaInput
				control={control}
				fieldName={'message'}
				label={t('elements.form.message.label')}
				placeholder={t(
					'main.notifications.components.create.form.message.placeholder',
				)}
			/>
			<ECheckboxWithTextInput
				control={control}
				fieldName={'isRequired'}
				text={t(
					'main.notifications.components.create.form.isRequired.placeholder',
				)}
			/>
		</div>
	);
};

export default NotificationCreateStep3;
